import { mailCreateDraftCommand } from './mail_createDraft';
import { mailWriteCommand } from './mail_write';

export const mailAppCommands = [
  mailCreateDraftCommand,
  mailWriteCommand,
];
